import { createStateContext } from '@change-corgi/core-react/context';

import type { PetitionEditPageData } from '../../pageData';

import { initialState } from './initialState';
import { mutations } from './mutations';
import type { PetitionEditPageState } from './types';

export const {
	StateContext: PetitionEditPageStateContext,
	StateProvider: PetitionEditPageStateContextProvider,
	useStateContext: usePetitionEditPageState,
} = createStateContext<
	PetitionEditPageState,
	typeof mutations,
	{ petition: PetitionEditPageData['petition']; defaultPersonPhotoUrl: string; defaultOrgPhotoUrl: string }
>({
	name: 'PetitionEditPageStateContext',
	mutations,
	initialState,
});
